export default {
  strict: true,
  namespaced: true,
  state: {
    isShow: false,
  },
  mutations: {
    show(state) {
      state.isShow = true;
    },
    hide(state) {
      state.isShow = false;
    },
  },
  actions: {
    show({ commit, dispatch, state, rootState }, rect) {
      commit('show');
    },
    hide({ commit, state }) {
      commit('hide');
      commit('map/clearShiftMap', null, { root: true });
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/views/destination_detail.js